<mat-list>
  <mat-list-item>
    <mat-checkbox [formControl]="formControls.followCenterVehicle"
      >Kijelölt jármű követése</mat-checkbox
    ></mat-list-item
  >
</mat-list>
